/*
  s_newsletter.js
*/

function submitNewsletter() {
   /* $('#input-newsletter').css('display', 'none');
    $('#newsletter-success').css('display', 'inline-block');
    $('#newsletter-title').css('color', '#000');
    $('#input-newsletter-submit').css('display', 'none');*/
    if (
    document.getElementById('input-newsletter').value.trim().length > 0 &&
    !submittedNewsletter
    ) {
    $.ajax({
      type: 'GET',
      url: 'https://audio.us21.list-manage.com/subscribe/post-json?u=347f6a08b00e1b6aa066161ac&id=ad78384af2&f_id=00ba86e6f0&c=?',
      data: $('#newsletter-form').serialize(),
      cache: false,
      dataType: 'jsonp',
      success: (res) => {
        if (res.result === 'success') {
          document.getElementById("newsletter-title").innerHTML = 'Subscribed!';
          $("#input-newsletter").css("visibility", "hidden");
          //$('#newsletter-success').show();
          submittedNewsletter = true;
         
        } else {
          console.log('Mailchimp error:', res.msg);
        }
      },
      error: (err) => {
        console.log('AJAX error:', err);
      }
    });
  }
}



$(document).ready(function(){
  /* SUBMIT NEWSLETTER */
    $('#input-newsletter').keypress(function (e) {
        if (e.which == 13) {
            e.preventDefault();
            submitNewsletter();
        }
    });
    try {
        document.getElementById('newsletter-form').addEventListener("submit", (e) => {
            e.preventDefault();
            submitNewsletter();
        });
    } catch(error) {
        console.log('error with form');
    }
});